import _ from 'underscore';
import { DeterministicView } from '@bingads-webui/deterministic-view';
import SettingsViewTemplate from './settings-view.pug';
import { getScope, getLevel } from './helpers';

export class SettingsView extends DeterministicView {
  initialize(state) {
    const scope = getScope(state.campaignId, state.adgroupId);
    const level = getLevel(state.adgroupId);
    super.setState(_.extend(state, { scope, level }));
    this.model.on('change', model => this.onModelChanged(model));
  }

  setState(state) {
    const scope = getScope(state.campaignId, state.adgroupId);
    const level = getLevel(state.adgroupId);
    super.setState(_.extend(state, { scope, level }));
  }

  onModelChanged() {
  }

  remove() {
    this.model.off('change');
    super.remove();
  }

  /**
   * Class name of the root element
   * @type {string}
   * @override
   */
  get className() { return 'settings-view'; }

  /**
   * Template of the SettingsView
   * @type {TemplateCallback}
   * @override
   */
  get template() { return SettingsViewTemplate; }
}
